import { FC } from 'react'
import cls from 'classnames'

import styles from './ItemId.module.scss'

export const ItemId: FC<PropsWithClassName> = ({ children, className }) => (
  <div className={cls(styles.root, className)}>{children}</div>
)
